//
//
//
//
//
//

import getRate from './share/rate/getRate'
import Rate from './share/rate/rate'
import LoanService from './service'
export default {
    components: {
        Rate
    },
    mixins:[getRate({get:LoanService.getRateData})],
    onShareAppMessage () {
        const sub_page = encodeURIComponent('/packageA/loan_computer/loan_rate')
        return this.getShareInfo({
            title: '这里有成都各银行贷款利率详情哦，点击了解~',
            path: `/index/main?sub_page=${sub_page}`
        })
    },
    onReady () {
        const { sub_page } = this.$route.query
        if (sub_page) {
            wx.navigateTo({
                url: decodeURIComponent(sub_page)
            })
        }
    },
}
